import { render, staticRenderFns } from "./activityFeedbackList.html?vue&type=template&id=2b4ab160&scoped=true&external"
import script from "./activityFeedbackList.vue?vue&type=script&lang=js"
export * from "./activityFeedbackList.vue?vue&type=script&lang=js"
import style0 from "./activityFeedbackList.css?vue&type=style&index=0&id=2b4ab160&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4ab160",
  null
  
)

export default component.exports